import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Typography,
} from "@mui/material";
import { useTheme } from "../../../contexts/ThemeContext";
import FlechaDerecha from "../../../assets/icons/Flecha_derecha.png";
import FlechaIzquierda from "../../../assets/icons/Flecha_Izquierda.png";
import Camion from "../../../assets/icons/Camion.png";
import CorazonImg from "./assets/corazon.png";
import Pag2Img from "./assets/pag2.png";
import Pag3Img from "./assets/pag3.png";
import Pag4Img from "./assets/pag4.png";
import Pag5Img from "./assets/Group 103.png";

const TUTORIAL_STORAGE_KEY = "listcourses_tutorial_shown";

export const TutorialModal = () => {
  const [open, setOpen] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const theme = useTheme();

  const isMobile = () => window.innerWidth <= 768;

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const helpParam = params.get("help");
    if (helpParam === "false" || helpParam === "0") return;
    const tutorialShown = localStorage.getItem(TUTORIAL_STORAGE_KEY);
    if (isMobile() && !tutorialShown) {
      setOpen(true);
    }
  }, []);

  useEffect(() => {
    const handleOpenTutorial = () => {
      setCurrentStep(0);
      setOpen(true);
    };
    window.addEventListener("open-tutorial", handleOpenTutorial);
    return () => window.removeEventListener("open-tutorial", handleOpenTutorial);
  }, []);

  const handleClose = () => {
    setOpen(false);
    localStorage.setItem(TUTORIAL_STORAGE_KEY, "true");
  };

  const handleNext = () => {
    if (currentStep < tutorialSteps.length - 1) {
      setCurrentStep(currentStep + 1);
    } else {
      handleClose();
    }
  };

  const handlePrevious = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleSkip = () => handleClose();

  const tutorialSteps = [
    {
      type: "welcome",
      title: "Bienvenido a tu espacio de capacitación",
      subtitle: "Comienza el nuevo camino para potenciar tu desarrollo como conductor de Abastible.",
      icon: Camion,
    },
    { type: "image", image: Pag2Img },
    { type: "image", image: Pag3Img },
    { type: "image", image: Pag4Img },
    { type: "image", image: Pag5Img },
    {
      type: "closing",
      title: "Tú mueves la energía",
      subtitle: "Nosotros te ayudamos a crecer.",
      subtitleBold: "¡Comencemos!",
      image: CorazonImg,
    },
  ];

  const step = tutorialSteps[currentStep];

  return (
    <Dialog
      open={open}
      onClose={handleSkip}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        style: {
          background: "linear-gradient(45deg, #fe5000, #f56e00 50%, #ed8a00)",
          borderRadius: "12px",
          padding: "8px",
          height: "min(620px, 90svh)",
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      {/* Omitir */}
      <Box sx={{ position: "relative" }}>
        <Typography
          onClick={handleSkip}
          sx={{
            position: "absolute",
            top: "8px",
            right: "24px",
            fontSize: "1.6rem",
            fontFamily: "Pop-Regular",
            color: "#ffffff",
            textDecoration: "underline",
            cursor: "pointer",
            zIndex: 10,
            "&:hover": { opacity: 0.7 },
          }}
        >
          Omitir
        </Typography>

        {/* Título solo en páginas welcome */}
        {step.type === "welcome" && (
          <DialogTitle sx={{ paddingBottom: "8px", paddingTop: "min(80px, 8svh)", textAlign: "center" }}>
            <Typography sx={{ fontSize: "2.4rem", fontFamily: "Pop-Bold", color: "#ffffff", textAlign: "center" }}>
              {step.title}
            </Typography>
          </DialogTitle>
        )}
      </Box>

      <DialogContent sx={{ padding: "8px 16px", flex: 1, display: "flex", alignItems: "center", overflow: "auto" }}>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            "@media (orientation: landscape) and (max-height: 500px)": {
              flexDirection: "row",
              gap: "16px",
            },
          }}
        >
          {/* Página 1 - Bienvenida */}
          {step.type === "welcome" && (
            <>
              <Typography
                sx={{
                  fontSize: "1.8rem",
                  fontFamily: "Pop-Regular",
                  color: "#ffffff",
                  marginTop: "-32px",
                  marginBottom: "min(48px, 5svh)",
                  textAlign: "center",
                  "@media (orientation: landscape) and (max-height: 500px)": {
                    flex: 1,
                    marginTop: 0,
                    marginBottom: 0,
                    textAlign: "left",
                  },
                }}
              >
                {step.subtitle}
              </Typography>
              <Box sx={{ width: "120px", height: "120px", display: "flex", alignItems: "center", justifyContent: "center", "@media (orientation: landscape) and (max-height: 500px)": { width: "80px", height: "80px", flexShrink: 0 } }}>
                <img src={step.icon} alt="Icono" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
              </Box>
            </>
          )}

          {/* Páginas 2-5 — solo imagen, misma altura que página 1 */}
          {step.type === "image" && (
            <Box sx={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
              <img
                src={step.image}
                alt={`Página ${currentStep + 1}`}
                style={{ width: "100%", maxHeight: "min(460px, 55svh)", objectFit: "contain", borderRadius: "8px" }}
              />
            </Box>
          )}

          {/* Página 6 - Cierre */}
          {step.type === "closing" && (
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%", paddingTop: "24px", gap: "12px", "@media (orientation: landscape) and (max-height: 500px)": { flexDirection: "row", paddingTop: "8px", alignItems: "center", gap: "16px" } }}>
              <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "12px", "@media (orientation: landscape) and (max-height: 500px)": { flex: 1, alignItems: "flex-start" } }}>
                <Typography sx={{ fontSize: "2.4rem", fontFamily: "Pop-Medium", color: "#ffffff", lineHeight: 1.2, textAlign: "center" }}>
                  {step.title}
                </Typography>
                <Typography sx={{ fontSize: "1.8rem", fontFamily: "Pop-Regular", color: "#ffffff", lineHeight: 1.4, textAlign: "center" }}>
                  {step.subtitle}{" "}
                  <Box component="span" sx={{ fontFamily: "Pop-Medium" }}>{step.subtitleBold}</Box>
                </Typography>
              </Box>
              <Box sx={{ display: "flex", justifyContent: "center", width: "100%", marginTop: "min(48px, 4svh)", "@media (orientation: landscape) and (max-height: 500px)": { width: "auto", marginTop: 0, flexShrink: 0 } }}>
                <img src={step.image} alt="Corazón" style={{ width: "180px", height: "auto", objectFit: "contain" }} />
              </Box>
            </Box>
          )}
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          padding: "min(16px, 1.5svh) 24px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "40px",
        }}
      >
        {/* Flecha Izquierda */}
        <Box
          onClick={handlePrevious}
          sx={{
            width: "40px", height: "40px",
            display: "flex", alignItems: "center", justifyContent: "center",
            cursor: currentStep > 0 ? "pointer" : "default",
            opacity: currentStep > 0 ? 1 : 0.3,
            transition: "opacity 0.3s",
            "&:hover": { opacity: currentStep > 0 ? 0.7 : 0.3 },
          }}
        >
          <img src={FlechaIzquierda} alt="Anterior" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
        </Box>

        {/* Indicadores de paso */}
        <Box sx={{ display: "flex", gap: "8px" }}>
          {tutorialSteps.map((_, index) => (
            <Box
              key={index}
              sx={{
                width: "10px", height: "10px",
                borderRadius: "50%",
                backgroundColor: index === currentStep ? theme?.colors?.primary || "#0da1bf" : "#cccccc",
                transition: "background-color 0.3s",
              }}
            />
          ))}
        </Box>

        {/* Flecha Derecha */}
        <Box
          onClick={handleNext}
          sx={{
            width: "40px", height: "40px",
            display: "flex", alignItems: "center", justifyContent: "center",
            cursor: "pointer",
            transition: "opacity 0.3s",
            "&:hover": { opacity: 0.7 },
          }}
        >
          <img src={FlechaDerecha} alt="Siguiente" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
        </Box>
      </DialogActions>
    </Dialog>
  );
};
